<template>
  <div class="c-profiles-popup c-profiles-popup--add">
    <div class="c-profiles-popup__headline">
      <h1
        v-dompurify-html="$t('subscriber.profile.add')"
        class="o-typography__headline4"
      ></h1>
    </div>
    <div class="c-profiles-popup__description">
      {{ $t('subscriber.profile.descriptionAddProfile') }}
    </div>

    <form @submit.prevent="add">
      <div class="c-profiles-popup__form-container">
        <ui-profile-edit-form
          :profile="profileData"
          :is-name-valid="isNameValid"
          :errors="errors"
        ></ui-profile-edit-form>
      </div>

      <div class="c-profiles-popup__buttons-container">
        <div
          class="o-button o-button--text c-profiles-popup__button"
          @click="back"
        >
          <span class="o-typography__label o-button__label">
            {{ $t('common.cancel') }}
          </span>
        </div>
        <button
          type="submit"
          class="o-button o-button--text c-profiles-popup__button"
        >
          <span class="o-typography__label o-button__label">
            {{ $t('common.continue') }}
          </span>
        </button>
      </div>
    </form>

    <span
      class="c-profiles-popup__icon-close o-icon o-icon--close o-typography--action"
      @click="back"
    ></span>
  </div>
</template>
<script>
  import { errorMapper } from '@/shared/utils';
  import ProfileAction from './profile-action';
  import UiProfileEditForm from './form.vue';

  export default {
    components: {
      UiProfileEditForm,
    },
    data() {
      return {
        subscriber: this.$services.resolve('subscriber'),
        profilesService: this.$services.resolve('profiles'),
        profileData: {},
        avatarEdit: false,
        isNameValid: true,
        errors: {},
      };
    },
    created() {
      this.profileData = {
        name: '',
        avatar: {},
        kids: false,
      };
    },
    methods: {
      add() {
        if (this.profileData.name.length === 0) {
          this.isNameValid = false;
          return;
        }

        if (this.loadPromise) {
          return this.loadPromise;
        }

        this.loadPromise = this.profilesService.create(this.profileData)
          .then(() => this.subscriber.fetch())
          .then(this.back)
          .catch((e) => {
            return errorMapper(this, e).then((errors) => {
              this.errors = errors;
            });
          })
          .then(() => {
            this.loadPromise = undefined;
          });
      },
      back() {
        this.$emit('action', ProfileAction.SHOW_LIST);
      },
    },
  };
</script>
